import type { PositionDraft, ProjectMeta } from '../types/project';

// export const UNITS = ['шт', 'г', 'кг', 'л'] as const;
export const UNITS = ['шт', 'кг', 'л'] as const;

export const REGIONS = [
    'Москва',
    'Ямало-Ненецкий автономный округ',
    'г. Салехард',
    'г. Новый Уренгой',
    'г. Ноябрьск',
    'Тюменская область',
    'Республика Коми',
    'Вся Россия',
] as const;

export const DEFAULT_REGION = 'Ямало-Ненецкий автономный округ';
// export const DEFAULT_REGION = 'Москва';

export const DELIVERY_ADDRESSES = [
    'г. Салехард, пр-кт Молодёжи, д. 9, офис 703',
    'г. Салехард, ул. Республики, д. 72',
    'г. Новый Уренгой, ул. 26 Съезда КПСС, д. 4',
    'г. Ноябрьск, ул. Ленина, д. 20',
    'г. Надым, ул. Зверева, д. 15',
];

export const DEFAULT_DELIVERY_ADDRESS = DELIVERY_ADDRESSES[0];

export const MAX_QTY = 10000000;

export const UPLOAD_LIMITS = {
    extensions: /\.(xlsx|xls)$/i,
    maxSize: 10 * 1024 * 1024,
    hint: 'Форматы .xlsx и .xls, до 10 МБ. Структуру можно взять из шаблона заявки.',
    short: '.xlsx и .xls, до 10 МБ',
};

export const REQUEST_LIMIT = { used: 14, total: 1000 };

export const TODAY_LABEL = '27 июля 2026 · понедельник';
